var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.changelog.id, staticClass: "p-2 px-3 position-relative" },
    [
      _c(
        "profile-avatar",
        _vm._b(
          {
            staticClass:
              "client-profile-owner-avatar changelog-owner position-absolute",
            staticStyle: { top: "10px" },
          },
          "profile-avatar",
          Object.assign({}, _vm.changelog.userDetails),
          false
        )
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-left": "1.9rem" } },
        [
          _c("i18n", {
            staticClass: "mb-0",
            attrs: {
              path: _vm.getChangelogSummaryMessage(
                _vm.changelog.type,
                _vm.origin
              ),
              tag: "p",
            },
            scopedSlots: _vm._u([
              {
                key: "name",
                fn: function () {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.getChangelogName(_vm.changelog.userDetails)
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "operation",
                fn: function () {
                  return [
                    _c("span", { staticClass: "text-lowercase" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.getChangelogOperation(
                              _vm.changelog.operation,
                              _vm.changelog.type
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "type",
                fn: function () {
                  return [
                    _c("span", { staticClass: "text-primary" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getChangelogType(_vm.changelog.type)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "clientProfile",
                fn: function () {
                  return [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "text-primary bold clickable hover-underline",
                        attrs: { to: _vm.clientProfileLink },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.clientProfileName) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "value",
                fn: function () {
                  return [
                    _c(
                      "span",
                      {
                        class: {
                          "text-primary": _vm.value.to,
                          "text-danger": !_vm.value.to,
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getClientProfileStatus(_vm.value.to)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "clientProfileOrigin",
                fn: function () {
                  return [
                    _c("client-profile-name-label", {
                      attrs: { "client-profile": _vm.value.from },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "clientProfileToMerge",
                fn: function () {
                  return [
                    _c("client-profile-name-label", {
                      attrs: { "client-profile": _vm.value.to },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("p", { staticClass: "tiny-f mb-0" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("formatDateHour")(_vm.changelog.insertionTimestamp)
                ) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }